import { render, staticRenderFns } from "./trifle-add.vue?vue&type=template&id=4af3965b&scoped=true&"
import script from "./trifle-add.vue?vue&type=script&lang=js&"
export * from "./trifle-add.vue?vue&type=script&lang=js&"
import style0 from "./trifle-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-add.vue?vue&type=style&index=1&id=4af3965b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3965b",
  null
  
)

export default component.exports